module.exports = __webpack_public_path__ + "img/rover-service-engineer.9f8ad1d2.png";